<template>
  <DataListStateful
    title="Отгрузки"
    resource="release-orders"
    store="releaseOrders"
    :columns="columns"
    :filter-options="filter"
  />
</template>

<script>
export default {
  data() {
    return {
      columns: [
        { title: "Ид", name: "id", sortable: true },
        { title: "Автор", name: "Author", sortable: true },
        {
          title: "Дата отгрузки План",
          name: "ReleaseOrderPlan",
          type: "date",
          width: 60,
          sortable: true,
          maxLength: 10,
        },
        {
          title: "Дата отгрузки Факт",
          name: "ReleaseOrderFact",
          type: "date",
          width: 60,
          sortable: true,
          maxLength: 10,
        },
        {
          title: "Время отгрузки",
          name: "ReleaseOrderTime",
          type: "time",
          width: 60,
          sortable: false,
          maxLength: 10,
          valueFn(value) {
            return value.ReleaseOrderFact;
          },
        },
        {
          title: "Объем остаток",
          name: "Volume",
          dataPath: "Volumes",
          sortable: true,
        },
        {
          title: "Количество мест остаток",
          name: "Place",
          dataPath: "Places",
          sortable: true,
        },
        {
          title: "Маршрут",
          name: "RouteNumber",
          dataPath: "RouteNumbers",
          type: "text-array",
          maxLength: 10,
          sortable: true,
        },
        {
          title: "Номер поставки",
          name: "ShippingNumber",
          dataPath: "ShippingNumbers",
          type: "text-array",
          width: 100,
          maxLength: 20,
          sortable: true,
        },
        {
          title: "Клиент",
          name: "Client",
          dataPath: "Clients",
          type: "text-array",
          width: 85,
          maxLength: 10,
          sortable: true,
          valueFn(value) {
            return [...new Set(value.Clients)];
          },
        },
        {
          title: "Продавец",
          name: "Factory",
          dataPath: "Factories",
          type: "text-array",
          maxLength: 10,
          sortable: true,
        },
        {
          title: "Номер проформы",
          name: "ProformNumber",
          dataPath: "ProformNumbers",
          type: "text-array",
          width: 100,
          maxLength: 20,
          sortable: true,
        },
        {
          title: "Статус",
          name: "State",
          dataPath: "State",
          type: "labelEnums",
          sortable: true,
        },
        {
          title: "Синхронизировано с ERP",
          name: "SyncedWithErp",
          dataPath: "SyncedWithErp",
          type: "flag",
          sortable: true,
          tooltip: "SyncedWithErp",
        },
      ],
      filter: {
        Id: {
          title: "Ид",
          type: "text",
        },
        Author: {
          title: "Автор отгрузки",
          type: "reference",
          resource: "users",
        },
        shippingNumber: {
          title: "Номер поставки",
          type: "text",
        },
        releaseOrderPlan: {
          title: "Дата отгрузки План",
          type: "date",
        },
        releaseOrderFact: {
          title: "Дата отгрузки Факт",
          type: "date",
        },
        client: {
          title: "Клиент",
          type: "reference",
          resource: "clients",
        },
        factory: {
          title: "Продавец",
          type: "reference",
          resource: "factories",
        },
        proformNumber: {
          title: "Номер проформы",
          type: "text",
        },
        states: {
          title: "Статус",
          type: "enum",
          resource: "release-order-states",
        },
        syncedWithErp: {
          title: "Синхронизация с ERP",
          type: "bool",
        },
      },
    };
  },
};
</script>
